import { action,  observable } from "mobx";
import router from '@/router';

class ResultStore {
  
  @observable subTitle = '等待分配设备中'
  
  @observable time = 5
  
  
  @action.bound routerPushHome () {
    router.push({path: 'home'})
  }
  
  @action.bound changeSubtitle () {
    const interval = setInterval(() => {
      if (this.time === 1) {
        clearInterval(interval)
       this.routerPushHome()
        return false
      }
      this.time = this.time -1
      this.subTitle = `${this.time}s后返回云手机首页`
    }, 1000)
  }
  
  @action.bound initResultStore () {
    this.subTitle = '5s后返回云手机首页';
    this.time = 5;
    this.changeSubtitle()
  }
  
  @action.bound resultStoreInit () {
    this.subTitle = ''
    this.time = 5
  }
  
}

export default new ResultStore();